/**
 * This file is part of the Haiman.
 * @link     : https://haiman.io/
 * @author   : Emil Zhai (root@derzh.com)
 * @modifier : Emil Zhai (root@derzh.com)
 * @copyright: Copyright (c) 2018 Hangzhou Haila Network Technology Co., Ltd.
 */

import { JX3 } from '@/store/types';
import * as api from '@/api/jx3';

export interface StoreJx3SearchAutocompleteState {
  type: string;
  kw: string;
  result: string[];
}

export default {
  namespaced: true,
  state: {
    type: null,
    kw: null,
    result: [],
  },
  actions: {
    [JX3.SEARCH_REQUEST_AUTOCOMPLETE]({ commit, state }, params) {
      params.kw = (params.kw || '').replace(/^\s+/gu, '').replace(/\s+$/u, '');
      if (state.type !== params.type || state.kw !== params.kw) {
        params.reload = true;
      }
      if (params.reload && params.kw) {
        commit(JX3.SEARCH_REQUEST_AUTOCOMPLETE, params);
        return new Promise((resolve, reject) => {
          api.getAutocomplete(state).then((res) => {
            commit(JX3.SEARCH_REQUEST_AUTOCOMPLETE_SUCCESS, res.data);
          }).catch(reject);
        });
      }
      return Promise.resolve();
    },
  },
  mutations: {
    [JX3.SEARCH_REQUEST_AUTOCOMPLETE](state, { reload, type, kw }) {
      if (reload) {
        state.type = type;
        state.kw = kw;
        state.result = [];
      }
    },
    [JX3.SEARCH_REQUEST_AUTOCOMPLETE_SUCCESS](state, result) {
      state.result = result;
    },
  },
};
